import React from "react";
import { iconsSources } from "../../helpers/icons";
import styles from "./Message.module.css";
import { hideNumber } from "../../helpers/titreHelper";
import cn from "classnames";

const Message = ({ message }) => {
  return (
    <div className={styles["wrapper"]}>
      {message && (
        <>
          <div className={styles["top"]}>
            <div className={styles["avatar"]}>
              <img src={message?.image || iconsSources[message?.channel]} alt={message?.author} />
            </div>
            <div className={styles["name"]}>
              {message?.author || hideNumber(message?.senderNumber)}
            </div>
          </div>
          <div className={styles["content"]}>
            <div className={styles["text"]}>{message?.content}</div>
            <div className={styles["attachments"]}>
              {message.attachments &&
                message.attachments.map((file) => {
                  if (file.type === "image") {
                    return <img key={file.url} src={file.url} alt={file.url} />;
                  }
                  return false;
                })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
